import React from 'react'
import HeaderFive from '../header/HeaderFive';
import BannerSeven from '../elements/BannerSeven';
import ServiceSix from '../elements/ServiceSix';
import AboutFive from '../elements/AboutFive';
import ServiceFIve from '../elements/ServiceFIve';
import FunFactsTwo from '../elements/FunFactsTwo';
import WorkingProcessTwo from '../elements/WorkingProcessTwo';
import PortfolioFIve from '../elements/PortfolioFIve';
import FaqThree from '../elements/FaqThree';
import TeamFour from '../elements/TeamFour';
import LargeVideoTwo from '../elements/LargeVideoTwo';
import TestimonialsBrand from '../elements/TestimonialsBrand';
import Contact from '../elements/Contact';
import CtaTwo from '../elements/CtaTwo';
import BlogSix from '../elements/BlogSix';
import Footer from '../elements/Footer';



function HomeSeven() {
    return (
        <div>
            <div className="index-seven">
                <HeaderFive/>
                <main>
                    <BannerSeven/>
                    <ServiceSix/>
                    <AboutFive/>
                    <ServiceFIve/>
                    <FunFactsTwo/>
                    <WorkingProcessTwo/>
                    <PortfolioFIve/>
                    <FaqThree/>
                    <TeamFour/>
                    <LargeVideoTwo/>
                    <TestimonialsBrand/>
                    <Contact/>
                    <CtaTwo/>
                    <BlogSix/>
                    <Footer/>
                </main>
            </div>
        </div>
    )
}

export default HomeSeven